import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareCursor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareCursor"><Path d="M3 3H21V11.5H19.5V4.5H4.5V19.5H11.5V21H3V3Z" fill="currentColor"/><Path d="M23.1302 14.264L10.6504 10.6514L14.263 23.1312L17.5471 17.5481L23.1302 14.264Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareCursor;
